module.exports = __webpack_public_path__ + "media/components/videos_internal/diabetes-6_3-23f8f49c1fd54c7f7acb187a94459b9d.jpg";